'use client';

import { useEffect } from 'react';

/**
 * Hook pour rediriger vers l'application mobile si l'utilisateur est sur mobile
 */
export const useAppRedirect = () => {
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isWebUrl = /^https?:\/\//.test(window.location.href);

    if (isMobile && isWebUrl) {
      const currentUrl = window.location.href;
      const appUrl = currentUrl.replace(
        /^https?:\/\/[^/]+/,
        'com.scorenco.app://scorenco.com'
      );

      // Vérifier si l'URL de destination est différente de l'URL actuelle
      // pour éviter les redirections en boucle
      if (appUrl !== currentUrl) {
        window.location.href = appUrl;
      }
    }
  }, []);
};
